import * as React from 'react'
import {IYoutubLinkComponentProps} from "./IYoutubLinkComponentProps";
import {IYoutubLinkComponentState} from "./IYoutubLinkComponentState";
import {IUploadVideoComponentProps} from "../uploadVideoComponent/IUploadVideoComponentProps";
import {toast, ToastContainer} from "react-toastify";
import axios from "axios";
import MenuComponent from "src/components/menuComponent/MenuComponent";
import HeaderComponent from "src/components/homeHeader/HeaderComponent";
import icon3 from "../../assets/images/Group.svg";
import icon2 from "../../assets/images/ion2.svg";
import * as gifActions from "../../actions/gifAction";
import Loader from 'react-loader-spinner'
import MagicDropzone from 'react-magic-dropzone';
import {WithContext as ReactTags} from 'react-tag-input';
import * as gifshot from 'gifshot'
import {connect} from 'react-redux'
import {Link, withRouter} from 'react-router-dom'
import YouTube from 'react-youtube';
import FooterComponent from "../footerComponent/FooterComponent";
import MenuLeftemobile from "../menuLeftMobile/MenuLeftemobile";
import * as modalActions from "../../actions/modalActions";

interface window {
    config: any
}

class YoutubLinkComponent extends React.Component<IYoutubLinkComponentProps, IYoutubLinkComponentState> {

    constructor(props: IYoutubLinkComponentProps) {
        super(props);
        this.state = {
            value: ".mp4 ",
            previews: [],
            accepted: [],
            img: '',
            interval: 0.1,
            seek: 0,
            offset: 0,
            numFrames: 5,
            type: '',
            percent: 0,
            youtube: '',
            title: '',
            description: '',
            tags: [],
            uploaded: false,
            duration: 0,
            videoId: '',

        }
        this.onReady = this.onReady.bind(this);
        this.onSeekChange = this.onSeekChange.bind(this);

    }

    componentDidMount() {


        if (this.props.location && this.props.location.state && this.props.location.state.link) {
            this.generateyoutubelink(this.props.location.state.link)
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IUploadVideoComponentProps>, nextContext: any): void {
        if (nextProps.location && nextProps.location.state && nextProps.location.state.link) {
            this.generateyoutubelink(nextProps.location.state.link)
        }


    }

    KeyCodes = {
        comma: 188,
        enter: 13,
    };

    delimiters = [this.KeyCodes.comma, this.KeyCodes.enter];

    handleDelete = (i) => {
        const {tags} = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition = (tag) => {
        tag.text = '#' + tag.text
        if (this.state.tags.filter(t => t.text === tag.text) == 0)

            this.setState(state => ({tags: [...state.tags, tag]}));
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        // re-render
        this.setState({tags: newTags});
    }

    async onSubmit() {

        if (this.props.authenticated && this.state.tags.length > 0) {
            event.preventDefault()
            fetch(this.state.img)
                .then(res => res.blob())
                .then(blob => this.props.handleSubmit(this.props.user, this.state.tags, this.state.title, this.state.description, blob, this.state.text,
                    (key) => {
                        this.props.history.push('/gif/' + key)
                        this.setState({uploaded: false})
                    }))
            this.setState({uploaded: true})
            await this.props.handleSubmit(this.props.user, this.state.tags, this.state.title, this.state.description, this.state.img, this.state.text,
                (key) => {
                    this.props.history.push('/gif/' + key)
                    this.setState({uploaded: false})
                })
        } else {
            if (!this.props.authenticated)
                this.props.openLoginModal(true , ()=>{})
            else if (this.state.tags.length <= 0)
                toast.info('Ajouter des tags')
        }
    }

    getVideoWidthAndHeight (url) {
		return new Promise((resolve, reject) => {
			// create the video element
			let video = document.createElement('video')

			// place a listener on it
			video.addEventListener( 'loadedmetadata', function () {
				// retrieve dimensions
				let height = this.videoHeight
				let width = this.videoWidth
				// send back result
				resolve({
					height : height,
					width : width
				})
			}, false)

			// start download meta-datas
			video.src = url
		})
	}

    creategif = async () => {

        if (this.state.duration > 0) {
            this.setState({
                percent: 0.1
            })
            event.preventDefault()
            let video, time, interval: any
            let image: any
            let images = []
            let waterMark
            (() => {

                waterMark = document.querySelector("#logogif");
            })();

            console.log(parseInt(this.state.end.width), 'width', parseInt(this.state.end.height), 'height')

            const trimmedVideo = `https://imaging.giphy.com/imaging/trim?media_url=${encodeURIComponent(this.props.location.state.link)}&start=${this.state.seek}&duration=${parseInt(this.state.numFrames) + 1}`

			const dimensions: any = await this.getVideoWidthAndHeight(trimmedVideo)

			console.log(dimensions)

			window['config'] = {
				width: dimensions.width,
				height: dimensions.height
			}

            window['config'] = {
                width: parseInt(this.state.end.width),
                height: parseInt(this.state.end.height)
            }
            gifshot.createGIF(
                {
                    // gifWidth: parseInt(this.state.end.width),
                    // gifHeight: parseInt(this.state.end.height),
                    // width: parseInt(this.state.end.width),
                    // height: parseInt(this.state.end.height),
                    gifWidth: dimensions.width,
					gifHeight: dimensions.height,
					width: dimensions.width,
					height: dimensions.height,
					videoWidth: dimensions.width,
					videoHeight: dimensions.width,
                    video: trimmedVideo,
                    /*video: video,*/
                    interval: 0.1,
                    offset: 0,
                    numFrames: this.state.numFrames * 10,
                    frameDuration: 0.001,
                    fontWeight: 'bold',
                    fontSize: '40px',
                    fontFamily: 'sans-serif',
                    fontColor: '#FFFFFF',
                    textAlign: 'center',
                    textBaseline: 'bottom',
                    sampleInterval: 20,
                    numWorkers: 2,
                    crossOrigin: "anonymous",

                    /*waterMark: waterMark,
                    waterMarkXCoordinate: this.state.end.width - 60,
                    waterMarkYCoordinate: this.state.end.height - 60,
                    waterMarkWidth:50,
                    waterMarkHeight: 50,
                    */textYCoordinate: 0,
                    text: this.state.text,
                    progressCallback: (captureProgress) => {
                        this.setState({percent: captureProgress * 100})
                        if (captureProgress * 100 === 100 && this.state.img !== '') {
                            this.setState({percent: 0})
                        }

                    },
                    completeCallback: (com) => {
                        console.log(com, 'complited')
                    },
                }, (obj) => {

                    console.log(obj)

                    if (!obj.error) {

                        this.setState({img: obj.image, percent: 0})
                    }
                });

            delete gifshot.instance
        }

    }

    onDrop = (accepted, rejected, links) => {

        let acc = accepted.map(v => acc = v)

        if (this.state.accepted.length > 0)
            console.log(this.state.accepted[0].type.split('/')[0])

        if (this.state.accepted.length == 0) {
            let newPreviews = [...this.state.previews, ...accepted.map(v => v.preview), ...links];

            let newAccepted = [...this.state.accepted, ...accepted.map(v => v), ...links];

            this.setState({
                previews: newPreviews,
                accepted: newAccepted,
                type: acc[0].type.split('/')[0]
            });
        }
    };

    notify = () => {
        toast("Wow so easy !");
        console.log('nooot')
    }

    generateyoutubelink = async (url: string) => {
        let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
        let id
        if (url.match(re))
{         id = url.match(re)[7];



        axios.get('https://imaging.giphy.com/fetch/video/info?url=' + encodeURIComponent(url)).then(res => {

            console.log(res)
            if (res.data.duration < 600) {
                this.setState({
                    duration: res.data.duration,
                    type: 'video',
                    videoId: id,
                    end: res.data,

                })

            } else {
                toast('la durée de la vidéo ne doit pas dépasser 10 minutes')
            }
        })
}
        else {
            toast('Lien Invalide')
        }

        /*
        let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
        let id = url.match(re)[7];
        let res =    await fetch('https://europe-west1-ttgif-3c665.cloudfunctions.net/links?id='+id);
        res.json().then(items => {
            if (items[0].sp && items.find( a=> a.sp === 'signature') ){

                toast.error("video protégée !", {
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            }
            else   if ( items[0].type &&  items.find( a=> a.type.includes('mp4'))   )
            {
                this.setState({
                    accepted: [{preview: items.find(a => a.type.includes('mp4')).url + '&origin=https://5c8b31010be0b70008b9e923--clever-tesla-9127eb.netlify.com', type: 'video/mp4'}],
                    type: 'video'
                })
            } else {toast.error("URL  Invalide !", {
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });}
        })*/
    }

    handleChange = () => {
        let text, interval, time, video, youtube, numFrames, textupload: any;
        (() => {
            text = document.querySelector("#text");
            textupload = document.querySelector("#textupload");
            interval = document.querySelector("#interval");
            video = document.querySelector("#video");
            numFrames = document.querySelector("#numFrames");
            youtube = document.querySelector("#youtube");
        })();
        if (textupload)
            textupload = textupload.value
        //console.log(youtube)
        if (youtube && !video) {
            if (youtube.value && youtube.value.includes('watch?v')) {
                youtube = youtube.value

                this.generateyoutubelink(youtube)
            }
        }
        if (text)
            text = text.value;
        else {
            text = this.state.text
        }
        if (this.state.type === 'video' && numFrames) {
            numFrames = numFrames.value
        }
        if (this.state.type !== 'video' && interval)
            interval = interval.value;
        else if (this.state.type === 'video')
            interval = 0.1;
        else
            interval = 0.5;
        this.setState({
            text: text,
            interval: interval,
            offset: time,
            numFrames: numFrames,
            title: textupload
        });
    }

    onRemove = (file) => {
        console.log(file, 'fffffffffffffffff')
        let acc = this.state.accepted.filter(a => a !== file)

        console.log(acc)

        this.setState({
            accepted: acc
        })

        console.log(acc, 'fff')
    }


    onSeekChange = (event) => {
        let seek: any;
        (() => {
            seek = document.querySelector("#seek");
        })();
        if (seek) {
            console.log(this.state.player, 'player')
            seek = seek.value
            this.setState({seek: seek}, () => {
                console.log(this.state.seek)
                this.state.player.seekTo(this.state.seek, true)
            })
        }

    }


    onReady = (event) => {
        // access to player in all event handlers via event.target
        // event.target.pauseVideo();

        this.setState({
            player: event.target,
        });

        setInterval(() => {

            if (this.state.player.getCurrentTime() > parseInt(this.state.seek) + parseInt(this.state.numFrames)) {
                this.state.player.seekTo(this.state.seek, true)
            }
        }, 1000);
    }


    render() {
        const {uploaded, img, accepted, type, percent} = this.state
        const opts = {
            height: '100%',
            width: '100%',
            margin: 'auto',
            playerVars: { // https://developers.google.com/youtube/player_parameters
                disablekb: 0,
                loop: 1,
                playsinline: 0,
                rel: 0,
                autoplay: 1, // Auto-play the video on load
                controls: 0, // Show pause/play buttons in player
                showinfo: 0, // Hide the video title
                modestbranding: 1, // Hide the Youtube Logo
                fs: 1, // Hide the full screen button
                cc_load_policy: 0, // Hide closed captions
                iv_load_policy: 3, // Hide the Video Annotations
                start: this.state.seek,
                autohide: 0, // Hide video controls when playing
                volume:0
            }
        };
        return (

            <div>
                <MenuLeftemobile/>
                <HeaderComponent/>
                <MenuComponent/>
                <ToastContainer/>

                {!uploaded ?

                    <div className='flex' style={{}}>
                        <div style={{
                            marginTop: '-30px',
                            minWidth: '300px',
                            maxWidth: '500px',
                            width:'90%'
                        }}>
                            {
                                img
                                    ?
                                    <div className='' style={{
                                        marginTop: '15%',

                                        position: 'relative',
                                        width:'100%'
                                    }}>

                                        <img src={this.state.img} style={{

                                        }}/>
                                        <div className="editbtn" style={{cursor: 'pointer'}}
                                             onClick={() => this.setState({
                                                 img: ''
                                             })}>
                                            <div className="btnIcon ">
                                                <img src={icon3}/>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    percent > 0 && img === '' ?
                                        <Loader type="Plane" color="#f34c71" height={80} width={80}/> :

                                        <div style={{
                                            marginTop: '40px',
                                            width: '100%',
                                            minHeight : 400,
                                            height: '405',
                                            background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)'

                                        }}>

                                            {this.state.videoId ?


                                            <div style={{
                                                paddingTop: '27%'
                                            }}>
                                                <YouTube

                                                style={{
                                                    width:'100%'
                                                }}
                                                videoId={this.state.videoId}
                                                opts={opts}

                                                controls={false}
                                                volume={0}

                                                onReady={this.onReady}
                                            />
                                            </div>

                                            : null}


                                        </div>




                                /*  <MagicDropzone
                                                style={{
                                                    width: 500 ,
                                                    height: 328,
                                                    background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)'

                                                }}
                                                className="Dropzone"
                                                accept={this.state.value}
                                                onDrop={this.onDrop}>
                                                <div className="Dropzone-content">
                                                    {this.state.accepted.length && this.state.accepted.length > 0 ? (
                                                        this.state.accepted.map((v, i) => (
                                                            <div>
                                                                {
                                                                    (
                                                                        v && this.state.accepted.length === 1 ?
                                                                            <div key={i} className="Dropzone-img-big" >

                                                                                <div>
                                                                                    <div onClick={() => this.onRemove(v)}
                                                                                         style={{
                                                                                             zIndex: 999,
                                                                                             width:'20px',
                                                                                             height:'20px',
                                                                                             background:'black',
                                                                                             color: 'white',
                                                                                             borderRadius: '50%',
                                                                                             opacity: 1.5,
                                                                                             position:'absolute'
                                                                                         }}><p style={{textAlign: 'center'}}>x</p>
                                                                                    </div>
                                                                                    < video
                                                                                        controls
                                                                                        controlsList="nodownload noremoteplayback nofullscreen"
                                                                                        className="Dropzone-img-big"
                                                                                        src={v.preview} id="video"
                                                                                        onChange={this.handleChange}></video>
                                                                                </div>
                                                                            </div> :
                                                                            v ?
                                                                                <div key={i}>
                                                                                    <div onClick={() => this.onRemove(v)}
                                                                                         style={{
                                                                                             float: 'right',
                                                                                             backgroundColor: '#999999',
                                                                                             color: 'white',
                                                                                             borderRadius: '40%',
                                                                                             pading: '5px',
                                                                                             opacity: 0.3
                                                                                         }}><p style={{margin: '5px'}}>x</p>
                                                                                    </div>
                                                                                    <img className="Dropzone-img"
                                                                                         src={v.preview}/>
                                                                                </div> :
                                                                                null
                                                                    )
                                                                }
                                                            </div>

                                                        ))
                                                    ) : (
                                                        "Déposez quelques fichiers sur moi!"

                                                    )}
                                                </div>
                                            </MagicDropzone>*/


                            }
                        </div>

                        <div className="" style={{
                            minWidth: '300px',
                            maxWidth: '500px',
                            width:'90%',
                            minHeight:400 ,
                            maxHeight:470,
                            height : 400

                        }}>

                            {
                                !img ?

                                    <form style={{
                                        width: '100%',
                                        height: '100%',
                                        background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
                                        marginTop: '12px'

                                    }}>
                                        <p style={{
                                            fontFamily: 'Gotham_Bold',
                                            lineHeight: 'normal',
                                            fontSize: '20px',
                                            color: 'white',
                                            paddingTop: '4px',
                                            paddingLeft: '21px',
                                            height: '15px'
                                            // paddingBottom : '5px'
                                        }}>

                                            Paramètres du diaporama
                                        </p>
                                        <p style={{
                                            fontFamily: 'Gotham_Bold',
                                            lineHeight: 'normal',
                                            fontSize: '14.2px',
                                            color: 'white',
                                            paddingLeft: '21px',
                                            width: '100%'

                                        }}>Ajouter ou supprimer une vidéo et réorganiser pour créer votre diaporama

                                        </p>
                                        <div style={{

                                            width: '90%',
                                            height: '35px',
                                            paddingLeft: '21px',
                                            marginTop: '15px'

                                        }}>
                                            <input
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    paddingLeft: '21px',
                                                }}
                                                placeholder='Ajouter du texte à afficher sur le GIF' type="text"
                                                value={this.state.text} id='text'
                                                onChange={this.handleChange}/>

                                        </div>
                                        <div style={{
                                            paddingLeft: '21px',
                                            marginTop: '10px'


                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                fontFamily: 'Gotham_Bold',
                                                lineHeight: 'normal',
                                                fontSize: '16px',
                                                color: 'white',
                                                width: '90%',
                                                justifyContent: 'space-between',
                                                marginTop: '10px'

                                            }}>
                                                <p>TEMPS DE DÉBUT</p>

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent : 'flex-end'

                                                }}>
                                                    <p style={{
                                                        fontSize: '72%',
                                                    }}>Secondes :</p>
                                                    <input type="number"
                                                           value={this.state.seek} min="0"
                                                           style={{
                                                               width: '17%',
                                                               height: '29px',
                                                               paddingLeft: '4px'

                                                           }}/>
                                                </div>
                                            </div>
                                            <input type="range" style={{
                                                width: '90%',
                                                marginTop: '5px'

                                            }} value={this.state.seek} min="0.0"
                                                   step="1.0"
                                                   max={this.state.duration}
                                                   id='seek'
                                                   onChange={this.onSeekChange}/>
                                        </div>

                                        <div style={{
                                            paddingLeft: '21px',
                                            marginTop: '10px'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                fontFamily: 'Gotham_Bold',
                                                lineHeight: 'normal',
                                                fontSize: '16px',
                                                color: 'white',
                                                width: '90%',
                                                justifyContent: 'space-between',

                                                marginTop: '10px'

                                            }}>
                                                <p> DURÉE</p>

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end',

                                                }}>
                                                    <p style={{
                                                        fontSize: '72%',

                                                    }}>Secondes :</p>
                                                    <input type="number"
                                                           value={this.state.numFrames} min="0" max="15"
                                                           onChange={this.handleChange}
                                                           step="0.1"

                                                           style={{
                                                               paddingLeft: '4px',
                                                               width: '30%',
                                                               height: '29px'

                                                           }}/>
                                                </div>
                                            </div>
                                            <input type="range" style={{
                                                width: '90%',
                                                marginTop: '5px'
                                            }} id="numFrames" value={this.state.numFrames} step="0.1" min="0.0"
                                                   max="15.0"
                                                   onChange={this.handleChange}/>
                                        </div>
                                        <div className="btn"
                                             style={{
                                                 float: 'right',
                                                 width: '40% ',
                                                 paddingRight: '10px',
                                                 paddingLeft: '21px',
                                                 marginTop: '5px',
                                                 cursor: 'pointer',
                                                 marginRight: '28px'
                                             }}
                                             onClick={() => this.creategif()}>
                                            <div className="btnIcon"><img src={icon2}/></div>
                                            <div className="btninsideContainer">
                                                <div className="firstTitle">APERÇU</div>
                                            </div>
                                        </div>
                                        {
                                            percent > 0 && img === '' ?
                                                <div>

                                                    <h1 style={{
                                                        width: '60%',
                                                        marginLeft: '45%',
                                                        marginTop: '0%'
                                                    }}> {Math.floor(percent)}%
                                                    </h1>
                                                </div>
                                                :
                                                null
                                        }
                                    </form> :


                                    <form style={{
                                        minWidth: '300px',
                                        maxWidth: '500px',
                                        width:'90%',
                                        minHeight:400 ,
                                        maxHeight:470,
                                        height : 400,
                                        background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
                                        marginTop: '12px'

                                    }}>

                                        <div className="" style={{

                                            width: '90%',
                                            height: '35px',
                                            paddingLeft: '21px',
                                            marginTop: '15px'

                                        }}>
                                            <input
                                                style={{

                                                    width: '100%',
                                                    height: '100%',
                                                    paddingLeft: '21px',
                                                    marginTop: '25px'
                                                }}
                                                placeholder='Ajouter un titre au GIF' type="text" value={this.state.title}
                                                id='textupload'
                                                onChange={this.handleChange}/>
                                        </div>
                                        <ReactTags
                                            tags={this.state.tags}
                                            handleDelete={this.handleDelete}
                                            handleAddition={this.handleAddition}
                                            handleDrag={this.handleDrag}
                                            delimiters={this.delimiters}
                                            inline={false}
                                            placeholder={ 'Cliquez sur entrée pour ajouter un nouveau tag'}
                                            classNames={{
                                                remove: 'removeClass2',
                                                tagInput: 'inputTags',
                                                selected: 'selectedClass btn',
                                                tag: 'tagClass'
                                            }}

                                            style={{
                                                marginTop: '40px'

                                            }}

                                        />

                                        <div className="btn"
                                             style={{

                                                 width: '80% ',
                                                 paddingRight: '10px',
                                                 paddingLeft: '21px',
                                                 marginLeft: '45px',
                                                 marginTop: '25px',
                                                 cursor: 'pointer'

                                             }}
                                             onClick={() => this.onSubmit()}>
                                            <div className="btnIcon"><img src={icon2}/></div>
                                            <div className="btninsideContainer">
                                                <div className="firstTitle">PUBLIER</div>
                                            </div>
                                        </div>
                                    </form>
                            }
                        </div>
                    </div> :
                    <Loader type="Plane" color="#f34c71" height={80} width={80}/>

                }
<FooterComponent/>
            </div>
        );
    }


}


function mapsStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        authenticated: state.auth.authenticated,
        user: state.auth.currentUser,
        newGif: state.Gif,
    };
}

const mapDispatchToProps = (dispatch: any, ownProps: IYoutubLinkComponentProps) => {
    return {
        handleSubmit: (user, tags, title, description, file, text, cb) => dispatch(gifActions.onSubmit(user, tags, title, description, file, text, cb)),
        openLoginModal: (type , cb) => dispatch(modalActions.loginModal(type, cb)),

    }
}

export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(YoutubLinkComponent))



// WEBPACK FOOTER //
// ./src/components/youtubeLinkComponent/YoutubLinkComponent.tsx